/**
 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
 */

/* globals window */

import { Comments, CommentsRepository } from '@ckeditor/ckeditor5-comments';
import { Mention } from '@ckeditor/ckeditor5-mention';
import { EditorWatchdog } from '@ckeditor/ckeditor5-watchdog';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { CKBox, CKBoxImageEdit } from '@ckeditor/ckeditor5-ckbox';
import { PictureEditing, ImageInsert, ImageResize, AutoImage, ImageCaption } from '@ckeditor/ckeditor5-image';

import { TOKEN_URL } from '@ckeditor/ckeditor5-ckbox/tests/_utils/ckbox-config.js';

// Umberto combines all `packages/*/docs` into the `docs/` directory. The import path must be valid after merging all directories.
import ClassicEditor from '../build-classic.js';

import './styles.css';

ClassicEditor.builtinPlugins.push( Essentials );
ClassicEditor.builtinPlugins.push( Comments );
ClassicEditor.builtinPlugins.push( CommentsRepository );
ClassicEditor.builtinPlugins.push( CKBox, CKBoxImageEdit, PictureEditing, ImageInsert, ImageResize, AutoImage, ImageCaption );

ClassicEditor.defaultConfig = {
	...ClassicEditor.defaultConfig,
	ckbox: {
		allowExternalImagesEditing: [ /^data:/, 'origin', /ckbox/ ],
		tokenUrl: TOKEN_URL
	}
};

window.ClassicEditor = ClassicEditor;
window.MentionPlugin = Mention;
window.EditorWatchdog = EditorWatchdog;
